import axios from "axios";
import { formatFt } from "@/lib/pricing";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMAIL_RE = /^\S+@\S+\.\S+$/;

export const todayPlusOne = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

export const initialBookingForm = () => ({
  name: "",
  phone: "",
  email: "",
  address: "",
  ac_type: "split",
  units_count: 1,
  preferred_date: todayPlusOne(),
  preferred_time: "morning",
  notes: "",
  notice_accepted: false,
  terms_accepted: false,
});

function validateStep1(form, t) {
  const e = {};
  if (!form.name.trim()) e.name = t.booking.errors.required;
  if (!form.phone.trim() || form.phone.trim().length < 6) e.phone = t.booking.errors.phone;
  if (!form.email.trim() || !EMAIL_RE.test(form.email)) e.email = t.booking.errors.email;
  return e;
}

function validateStep2(form, t) {
  const e = {};
  if (!form.address.trim()) e.address = t.booking.errors.required;
  return e;
}

function validateStep3(form, t) {
  const e = {};
  if (!form.preferred_date) e.preferred_date = t.booking.errors.required;
  if (!form.notice_accepted) e.notice_accepted = t.booking.errors.consent;
  if (!form.terms_accepted) e.terms_accepted = t.booking.terms.error;
  return e;
}

const VALIDATORS = { 1: validateStep1, 2: validateStep2, 3: validateStep3 };

export function validateBookingStep(step, form, t) {
  const validator = VALIDATORS[step];
  return validator ? validator(form, t) : {};
}

export async function submitBooking(form, lang) {
  const payload = {
    ...form,
    units_count: Number(form.units_count) || 1,
    language: lang,
  };
  const { data } = await axios.post(`${API}/bookings`, payload);
  return data;
}

// Maps the calculator result onto booking form fields (units, type, note).
export function calcPrefillFields(prefill, t) {
  return {
    units_count: prefill.indoor,
    ac_type: prefill.indoor > 1 ? "multi_split" : "split",
    notes: t.calculator.prefillNote
      .replace("{indoor}", String(prefill.indoor))
      .replace("{outdoor}", String(prefill.outdoor))
      .replace("{total}", formatFt(prefill.total)),
  };
}
